import { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";

const navLinks = [
  { to: "/", label: "首页" },
  { to: "/category", label: "分类频道" },
  { to: "/article", label: "动漫资讯" },
  { to: "/about", label: "关于我们" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const kw = keyword.trim();
    navigate(kw ? `/category/all?q=${encodeURIComponent(kw)}` : "/category");
  };

  const solid = scrolled || location.pathname !== "/" || open;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        solid ? "bg-background-50/95 backdrop-blur shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 md:h-20 max-w-7xl items-center justify-between px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-rocket-2-fill text-lg"></i>
          </span>
          <span className={`font-heading text-xl md:text-2xl ${solid ? "text-foreground-900" : "text-foreground-950"}`}>
            动漫网
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              className={({ isActive }) =>
                `rounded-md px-4 py-2 text-sm font-medium whitespace-nowrap transition-colors ${
                  isActive
                    ? "bg-primary-100 text-primary-700"
                    : solid
                      ? "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                      : "text-foreground-950/80 hover:bg-white/10 hover:text-white"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2 md:gap-3">
          <form onSubmit={handleSearch} className="hidden lg:flex items-center">
            <div className="flex items-center overflow-hidden rounded-full border border-background-200 bg-background-100 px-3 focus-within:ring-2 focus-within:ring-primary-300">
              <i className="ri-search-line text-sm text-foreground-400"></i>
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索动漫 / 文章"
                className="w-40 py-2 pl-2 text-sm bg-transparent outline-none text-foreground-800 placeholder:text-foreground-400"
              />
            </div>
          </form>
          <Link
            to="/category"
            className="hidden md:inline-flex items-center whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition hover:bg-primary-600"
          >
            立即进入
          </Link>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className={`md:hidden flex h-10 w-10 items-center justify-center rounded-md ${
              solid ? "text-foreground-900 bg-background-100" : "text-white bg-white/10"
            }`}
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-3">
          <nav className="flex flex-col gap-1">
            {navLinks.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                className={({ isActive }) =>
                  `rounded-md px-3 py-2.5 text-sm font-medium ${
                    isActive ? "bg-primary-100 text-primary-700" : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>
          <form onSubmit={handleSearch} className="mt-3">
            <div className="flex items-center overflow-hidden rounded-full border border-background-200 bg-background-100 px-3">
              <i className="ri-search-line text-sm text-foreground-400"></i>
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索动漫 / 文章"
                className="w-full py-2.5 pl-2 text-sm bg-transparent outline-none text-foreground-800"
              />
            </div>
          </form>
        </div>
      )}
    </header>
  );
}